import z from 'zod'

const MAX_FILE_SIZE = 100 * 1024 * 1024 // 100MB
export const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']

export const fileSchema = z
  .any()
  .refine((file: File) => file instanceof File, {
    message: 'Invalid file type',
  })
  .refine((file: File) => file.size <= MAX_FILE_SIZE, {
    message: `File size should not exceed ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
  })

export const imageSchema = fileSchema.refine((image: File) => IMAGE_TYPES.includes(image.type))

declare global {
  namespace TrinityAPI {
    type GenericFileType = z.infer<typeof fileSchema>
    type GenericImageType = z.infer<typeof imageSchema>
  }
}
